import { css } from 'reakit/styled';
import { theme } from 'styled-tools';
import 'styled-selector';
import selector from '../styled/selector.js';
import 'lodash/get';
import space from '../styled/space.js';
import styled from '../styled/index.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';

var Caption = styled(Box).withConfig({
  displayName: "styled__Caption",
  componentId: "y1jyri-0"
})(["caption-side:", ";&{", ";}"], function (props) {
  return props.position;
}, theme('fannypack.Table.Caption.base'));
var TableCell = styled(Box).withConfig({
  displayName: "styled__TableCell",
  componentId: "y1jyri-1"
})(["padding:", "rem;&{", ";}"], theme('fannypack.Table.spacing'), theme('fannypack.Table.Cell.base'));
var TableFoot = styled(Box).withConfig({
  displayName: "styled__TableFoot",
  componentId: "y1jyri-2"
})(["font-weight:bold;&{", ";}&{", ";}"], function (props) {
  return props.hasBorder && css(["border-top:2px solid ", ";"], theme('fannypack.Table.borderColor'));
}, theme('fannypack.Table.Foot.base'));
var TableHead = styled(Box).withConfig({
  displayName: "styled__TableHead",
  componentId: "y1jyri-3"
})(["border:unset;&{", ";}&{", ";}"], function (props) {
  return props.hasBorder && css(["border-bottom:2px solid ", ";"], theme('fannypack.Table.borderColor'));
}, theme('fannypack.Table.Head.base'));
var tableHeadCellText = css(["font-weight:bold;&{", ";}"], theme('fannypack.Table.HeadCell.text'));
var TableHeadCell = styled(Box).withConfig({
  displayName: "styled__TableHeadCell",
  componentId: "y1jyri-4"
})(["padding:", "rem;vertical-align:middle;", " &{", ";}"], theme('fannypack.Table.spacing'), tableHeadCellText, theme('fannypack.Table.HeadCell.base'));
var TableRow = styled(Box).withConfig({
  displayName: "styled__TableRow",
  componentId: "y1jyri-5"
})(["&{", ";}"], theme('fannypack.Table.Row.base'));
var TableBody = styled(Box).withConfig({
  displayName: "styled__TableBody",
  componentId: "y1jyri-6"
})(["", ";&{", ";}"], function (props) {
  return props.hasBorders && css(["& ", ":not(:last-child){border-bottom:1px solid ", ";}"], selector(TableRow), theme('fannypack.Table.borderColor'));
}, theme('fannypack.Table.Body.base'));
var hoverableProperties = css(["& ", " ", ":hover{background-color:", " !important;}"], selector(TableBody), selector(TableRow), theme('fannypack.Table.hover.backgroundColor'));
var stripedProperties = css(["& ", " ", ":nth-child(even){background-color:", ";}"], selector(TableBody), selector(TableRow), theme('fannypack.Table.striped.backgroundColor'));
var responsiveAttributes = css(["@media screen and (max-width:", "px){& ", "{display:none;}& ", " ", ":not(:last-child){border-bottom:1px solid ", ";}& ", " ", "{display:block;text-align:left !important;&::before{display:block;content:attr(data-content);", "}}& ", " ", "{display:block;text-align:left !important;}}"], function (props) {
  return theme("fannypack.layout." + props.responsiveBreakpoint + "Breakpoint");
}, selector(TableHead), selector(TableBody), selector(TableRow), theme('fannypack.Table.borderColor'), selector(TableBody), selector(TableCell), tableHeadCellText, selector(TableFoot), selector(TableCell));
var Table = styled(Box).withConfig({
  displayName: "styled__Table",
  componentId: "y1jyri-7"
})(["border-collapse:collapse;border-spacing:0;text-align:left;width:100%;&:not(:last-child){margin-bottom:", "rem;}&{", "}&{", ";}&{", ";}&{", ";}&{", ";}"], space(4), function (props) {
  return props.isVerticallyCentered && css(["& ", "{vertical-align:middle;}"], selector(TableCell));
}, function (props) {
  return props.isResponsive && responsiveAttributes;
}, function (props) {
  return props.isHoverable && hoverableProperties;
}, function (props) {
  return props.isStriped && stripedProperties;
}, theme('fannypack.Table.base'));

export default Table;
export { Caption, Table, TableBody, TableCell, TableFoot, TableHead, TableHeadCell, TableRow, hoverableProperties, responsiveAttributes, stripedProperties, tableHeadCellText };
